import Vue from "vue";
import Router from "vue-router";

import AuthorityManage from "./modules/authority-manage";
import ContentManage from "./modules/content-manage";
import FormManage from "./modules/form-manage";
import SeoManage from "./modules/seo-manage";
import CaseManage from "./modules/case-manage";
import SolutionManage from "./modules/solution-manage";
import CollegeManage from "./modules/college-manage";
import Store from "../store/index";

const Login = () => import("@/vuepage/Login");
const Index = () => import("@/vuepage/Index");
Vue.use(Router);

const children = [
  ...AuthorityManage,
  ...ContentManage,
  ...FormManage,
  ...SeoManage,
  ...CaseManage,
  ...SolutionManage,
  ...CollegeManage,
];

const router = new Router({
  routes: [
    {
      path: "",
      redirect: "/login",
    },
    {
      path: "/login",
      component: Login,
    },
    {
      path: "/index",
      component: Index,
      children,
    },
  ],
  // mode: 'history',
});

const keepAliveRouter = ["PurchaseRecord", "UserDetail", "UserList"]; // 请先配置好组件的name属性和路由的name保持一致
Store.dispatch("addKeepAlive", keepAliveRouter);
router.beforeEach((to, from, next) => {
  const pageContainer = document.getElementById("page-container");
  setTimeout(() => {
    if (pageContainer && pageContainer.scrollTop) pageContainer.scrollTop = 0;
  }, 500);
  if (keepAliveRouter.includes(to.name)) {
    Store.dispatch("addKeepAlive", to.name);
  }
  next();
});

export default router;
